<div class="bv-individuals__toolbar">
    <div class="bv-individuals__filters">
        <input type="text" class="form-control" placeholder="{{'PLACEHOLDERS.SEARCH_BY_NAME' | translate}} / {{'LABELS.LEGAL_ENTITY' | translate}}"
            (keyup)="searchForm($event.target.value , 'name')" />
        <input type="text" class="form-control" placeholder="{{'PLACEHOLDERS.SEARCH_BY_LAST_NAME' | translate}}"
            (keyup)="searchForm($event.target.value , 'lastname')" />
    </div>
    <div class="bv-individuals__actions">
        <button class="bv-btn bv-btn--secondary" (click)="downloadFullReport()">
            <mat-icon>file_download</mat-icon>
            {{'BUTTONS.DOWNLOAD' | translate}} {{'IND.FULL_REPO' | translate}}
        </button>
        <a [routerLink]="'/individuals/profile/add'" class="bv-btn bv-btn--primary">
            <mat-icon>add</mat-icon>
            {{'BUTTONS.NUEVA' | translate}} {{'LABELS.PERSON' | translate}}
        </a>
    </div>
</div>

<mat-tab-group class="bv-individuals__tabs" (selectedTabChange)="tabChange($event)">
    <mat-tab label="{{'LABELS.INDIVIDUALS' | translate}}">
        <div class="bv-individuals__table bv-scrollbar">
            <app-table [dataSource]="individuals" [columns]="columnsPerson" (actionClicked)="handleClick($event)"
                [loading]="isLoading" [pageSize]="size">
                <span paginator>
                    <mat-paginator #MatPaginator1 [length]="total" (page)="changePage($event)"
                        [pageSizeOptions]="[25, 50, 100]">
                    </mat-paginator>
                </span>
            </app-table>
        </div>
    </mat-tab>
    <mat-tab label="{{'LABELS.LEGAL_ENTITIES' | translate}}">
        <div class="bv-individuals__table bv-scrollbar">
            <app-table [dataSource]="individuals" [columns]="columnsLegals" (actionClicked)="handleClick($event)"
                [loading]="isLoading" [pageSize]="size">
                <span paginator>
                    <mat-paginator #MatPaginator2 (page)="changePage($event)" [length]="total"
                        [pageSizeOptions]="[25, 50, 100]">
                    </mat-paginator>
                </span>
            </app-table>
        </div>
    </mat-tab>
</mat-tab-group>
